import React from 'react';
import { connect } from 'react-redux';
import store from '../../../../../helpers/store';
import unique from 'array-unique';
import * as CMBActions from '../../actions';
import { CMB_MODE } from '../../types';
import PhoneInput from '../../../../controls/phoneInput';
import Button from '../../../../controls/button';
import Dropdown from '../../../../controls/dropdown';
import Consent from '../../../../controls/consent';
import DateInput from './../../../../controls/dateinput';
import './CMBForm.scss';

class CMBForm extends React.Component {
    constructor(props) {
        super(props);

        const intervals = this.getIntervals();
        if (intervals !== undefined) {
            this.state = {
                days: unique(intervals.map(interval => interval.cmbDelayedIntervalDay)),
                dates:
                    this.props.cmbStore.dateValue != ''
                        ? this.filterByDays(
                              this.filterById(this.props.cmbStore.dateValue)[0]
                                  .cmbDelayedIntervalDay
                          )
                        : this.filterByDays(intervals[0].cmbDelayedIntervalDay),
                dateValue: intervals[0].cmbDelayedIntervalId
            };
        } else {
            this.state = {
                days: [],
                dates: [],
                dateValue: 0
            };
        }
    }

    getIntervals() {
        return this.props.config.cmbDelayedIntervals;
    }

    filterByDays(day) {
        return this.getIntervals().filter(e => e.cmbDelayedIntervalDay === day);
    }

    filterById(id) {
        return this.getIntervals().filter(e => e.cmbDelayedIntervalId === id);
    }

    onPhoneChange(data) {
        const intervals = this.getIntervals();
        if (!this.props.cmbStore.dateValue && intervals) {
            CMBActions.saveDate(intervals[0].cmbDelayedIntervalId);
        }

        if (data.isValidDigits) {
            CMBActions.savePhone(data.number, data.isValidLength);
            CMBActions.saveValidationState(this.validateForm());
        }
    }

    onModeChange() {
        const intervals = this.getIntervals();
        if (this.props.cmbStore.dateValue == '' && intervals) {
            CMBActions.saveDate(intervals[0].cmbDelayedIntervalId);
        }
        CMBActions.saveMode(
            this.props.cmbStore.mode === CMB_MODE.DELAYED ? CMB_MODE.IMMEDIATE : CMB_MODE.DELAYED
        );
        CMBActions.saveValidationState(this.validateForm());
    }

    onDayChange(newValue) {
        const dates = this.filterByDays(newValue);

        CMBActions.saveDate(dates[0].cmbDelayedIntervalId);
        CMBActions.saveValidationState(this.validateForm());

        this.setState({
            dates: dates
        });
    }

    onHourChange(newValue) {
        CMBActions.saveDate(newValue);
        CMBActions.saveValidationState(this.validateForm());
    }

    onDateChange(interval) {
        CMBActions.saveDate(interval);
        CMBActions.saveValidationState(this.validateForm());
    }

    onConsentChange(data) {
        CMBActions.saveConsent(data);
        CMBActions.saveValidationState(this.validateForm());
    }

    validatePhone(number) {
        let isValidDigits = false;
        let isValidLength = false;

        if (number.length > 0 && number.match(/^[1-9]{1}[0-9]{0,8}$/)) {
            isValidDigits = true;
            if (number.length === 9) {
                isValidLength = true;
            }
        } else if (number.length === 0) {
            isValidDigits = true;
        }

        return { isValidDigits, isValidLength };
    }

    validateForm() {
        const state = store.getState();
        return state.cmb.consent
            ? state.cmb.mode === CMB_MODE.IMMEDIATE
                ? state.cmb.isPhoneValid
                : state.cmb.isPhoneValid && state.cmb.dateValue.length > 0
            : false;
    }

    render() {
        const { config, cmbStore } = this.props;
        const selectedInterval =
            cmbStore.dateValue != ''
                ? this.filterById(cmbStore.dateValue)
                : config.cmbDelayedIntervals;

        return (
            <form className="cmb-form">
                <h1>{config.cmbHeader || 'Zamów bezpłatną rozmowę z konsultantem'}</h1>

                <div className="title">
                    {config.cmbInfo && config.cmbInfo != '' ? (
                        <div
                            className="cmb-popup-right-column--info"
                            dangerouslySetInnerHTML={{
                                __html: config.cmbInfo
                            }}
                        ></div>
                    ) : null}
                    {this.props.title || (
                        <React.Fragment>
                            <p>Chcesz skorzystać z naszej oferty?</p>
                            <p>Zostaw swój numer telefonu:</p>
                        </React.Fragment>
                    )}
                </div>

                <PhoneInput
                    placeholder="Wpisz swój numer"
                    value={cmbStore.phoneValue}
                    onChange={data => this.onPhoneChange(data)}
                />

                {!this.props.newStyle &&
                config.cmbDelayedAvailable &&
                cmbStore.mode === CMB_MODE.DELAYED &&
                config.cmbDelayedIntervals.length > 0 ? (
                    <React.Fragment>
                        <Dropdown
                            onChange={newValue => this.onDayChange(newValue)}
                            value={selectedInterval[0].cmbDelayedIntervalDay}
                            options={this.state.days.map(day => ({ value: day, label: day }))}
                        />
                        <Dropdown
                            onChange={newValue => this.onHourChange(newValue)}
                            value={selectedInterval[0].cmbDelayedIntervalId}
                            options={this.state.dates.map(interval => ({
                                value: interval.cmbDelayedIntervalId,
                                label: interval.cmbDelayedIntervalHour
                            }))}
                        />
                    </React.Fragment>
                ) : null}

                <Button
                    className="primary submit"
                    disabled={!this.props.cmbStore.isFormValid}
                    onClick={() => this.props.onSubmit()}
                    text={
                        cmbStore.mode === CMB_MODE.IMMEDIATE || cmbStore.mode === ''
                            ? this.props.buttonTitle
                                ? this.props.buttonTitle
                                : 'Zadzwońcie do mnie teraz'
                            : cmbStore.mode === CMB_MODE.DELAYED
                            ? 'Czekam na telefon'
                            : ''
                    }
                />

                {config.cmbImmediateAvailable &&
                    config.cmbDelayedAvailable &&
                    (cmbStore.mode === CMB_MODE.IMMEDIATE || cmbStore.mode === '') && (
                        <Button
                            className="transparent"
                            disabled={false}
                            onClick={() => this.onModeChange()}
                            text={
                                this.props.scheduledTitle
                                    ? this.props.scheduledTitle
                                    : 'Zamów w innym terminie'
                            }
                        />
                    )}

                {config.cmbImmediateAvailable &&
                config.cmbDelayedAvailable &&
                cmbStore.mode === CMB_MODE.DELAYED ? (
                    <p className="cancelLink link underline" onClick={() => this.onModeChange()}>
                        Anuluj
                    </p>
                ) : null}

                {this.props.newStyle &&
                config.cmbDelayedAvailable &&
                cmbStore.mode === CMB_MODE.DELAYED &&
                config.cmbDelayedIntervals.length > 0 ? (
                    <div className="cmbDelayed">
                        <div>
                            <DateInput
                                className="primary"
                                placeholder="Wybierz datę"
                                intervals={config.cmbDelayedIntervals}
                                value={selectedInterval[0].cmbDelayedIntervalId}
                                onChange={interval => this.onDateChange(interval)}
                                format="YYYY-MM-DD / H:mm"
                                icon={true}
                                autoSelectDay={true}
                                hideOnTimeSelect={true}
                                isMobile={this.props.isMobile || false}
                            />
                        </div>
                    </div>
                ) : null}

                <Consent
                    consentId={config['cmbConsentId'] ? config['cmbConsentId'] : null}
                    informationId={config['cmbInformationId'] ? config['cmbInformationId'] : null}
                    isChecked={cmbStore.consent}
                    onChange={data => this.onConsentChange(data)}
                />
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        cmbStore: state.cmb
    };
};

export default connect(mapStateToProps)(CMBForm);
